import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemBase } from '../list-row-item-base';
import { ItemsListRowItemDisplayValueComponent } from '@fi-app/components/items-list/list-row/list-row-item/display-value/display-value.component';

@Component({
    selector: 'fi-items-list-row-item-span-plain',
    template: `
        <span class="CcmListItemTextOverflow CcmListItemName" [attr.title]="getDisplayValue()">
          {{ getDisplayValue() }}
          @if (getDisplayValue()) {
            <a
              [fiStateSref]="head.ChildProperties.Sref"
              [fiStateSrefParams]="head.ChildProperties.SrefParams(data)"
              (click)="onClickChild($event)"
              class="BrandedColorHover ChildProperty list-row-click-no-select"
              >{{ data[head.ChildPropertyName] }}</a
              >
            }
          </span>
        `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-row-item-span-plain' },
    standalone: false,
})
export class ItemsListRowItemSpanChildAComponent extends ItemsListRowItemBase {
    getDisplayValue() {
        return ItemsListRowItemDisplayValueComponent.GetDisplayValue(this.data, this.head);
    }

    onClickChild($event: MouseEvent) {
        if (this.head.ChildProperties.onClick) this.head.ChildProperties.onClick($event, this.data, this.parentData);
    }
}
